// extracted by mini-css-extract-plugin
export default {"frame":"PrimaryEventImage_frame__dP9aa","background":"PrimaryEventImage_background__p+O6F","foreground":"PrimaryEventImage_foreground__HuDEx"};